module.exports = __webpack_public_path__ + "static/media/search-grey.ae7bb568.svg";